import React from "react"
import PropTypes from "prop-types"
import Component from "./Component";
import ShimmerLoader from "./ShimmerLoader";
import {isArray} from "lodash";

class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emptyOption: this.props.emptyOption,
            options: [...this.props.options],
            optionsValue: this._getOptionValueFunction(),
            optionsLabel: this._getLabelFunction(),
            multiselectValues: [],
            multiselectItems: [],
            filter: "",
            lastValue: "",
            searchText: ""
        };
        this.input = React.createRef();
        this.dropdown = React.createRef();
        this.placeholderRef = React.createRef(); // Correctly initialize placeholderRef
        this.observer = React.createRef(); // Correctly initialize observer
        this._onInputKeyDown = this._onInputKeyDown.bind(this);
    }

    componentDidMount() {
        const value = this.getValue();
        this.setState({
            ...this.state,
            filter: value,
            lastValue: value,
        });

        this.input.current.addEventListener("keydown", this._onInputKeyDown, false);

        // Set up IntersectionObserver
        this.createObserver();
    }

    createObserver() {
        if (this.props.loading) return;
        if (this.observer.current) this.observer.current.disconnect();

        this.observer.current = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.props.loading && this.props.hasMoreOptions) {
                    if (this.currentHover) {
                        //hover item which will be visible after filtering
                        let item = this.currentHover;
                        this.setState({...this.state, currentHoverItem: item});
                    }
                    this.props.fetchMoreOptions();  // Trigger loading the next page

                }
            });
        });

        if (this.placeholderRef.current) {
            this.observer.current.observe(this.placeholderRef.current);
        }
    }

    componentWillUnmount() {
        this.input.current.removeEventListener("keydown", this._onInputKeyDown, false);

        // Clean up IntersectionObserver
        if (this.observer.current) {
            this.observer.current.disconnect();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isMultiSelect && (prevProps.options !== this.props.options || this.valueDidUpdate(prevProps))) {
            const value = this.getValue();
            this.setState({
                ...this.state,
                options: [...this.props.options],
                filter: value,
                lastValue: value,
            }, () => this._onInputFocus(false));
            return;
        }

        let multiSelectOptions = {};
        if (prevProps.options !== this.props.options || this.valueDidUpdate(prevProps)) {
            const value = this.getValue();
            if (this.props.isMultiSelect) {
                const valued = super.getValue();
                if (valued && isArray(valued) && valued.length > 0) {
                    multiSelectOptions.multiselectValues = [...(valued.map(item => this.getOptionValue(item)))];
                    if (this.props.isSelectionAnObject) {
                        multiSelectOptions.multiselectItems = [...valued];
                    }
                    // multiSelectOptions.multiselectItems = [...this.state.multiselectItems.filter(item => multiSelectOptions.multiselectValues.includes(this.getOptionValue(item)))];
                } else {
                    multiSelectOptions.multiselectValues = [];
                    multiSelectOptions.multiselectItems = [];
                }
            }
            if (this.state.currentHoverItem) {
                //hover item which will be visible after filtering
                this.currentHover = this.state.currentHoverItem;
                let item = this.currentHover;
                if (this.currentHover.classList.contains("empty")) {
                    item = this.currentHover.nextElementSibling;
                } else {
                    let index = parseInt(this.currentHover.getAttribute("data-index"));
                    while (this.props.options.length <= index && item) {
                        item = item.previousElementSibling;
                        index--;
                    }
                }
                item && this._hoverItem(item);
            }
            this.setState({
                ...this.state,
                emptyOption: this.props.emptyOption,
                options: [...this.props.options],
                optionsValue: this._getOptionValueFunction(),
                optionsLabel: this._getLabelFunction(),
                filter: value,
                lastValue: value,
                hasMoreOptions: this.props.hasMoreOptions,
                ...multiSelectOptions
            }, () => this._onInputFocus(false));

        }
        this.createObserver();

    }

    render() {
        return (
            <label
                className={"field has-float-label dropdown select loadable " + (this.props.className ? this.props.className : "")}>
                {(this.state.isDropdownOpen && this.props.isMultiSelect) ? (

                    <input
                        ref={this.input}
                        // id={"filter_selection_" + (this.props.id || this.props.name) + "_input"}
                        value={this.state.searchText}
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        spellCheck="false"
                        className="input"
                        onFocus={() => {
                            this._onInputFocus.bind(this);
                            this.setState({isDropdownOpen: true})
                        }}
                        onBlur={() => {
                            this._onInputBlur.bind(this);
                            this.setState({isDropdownOpen: false})
                        }}
                        onChange={this._onInputChange.bind(this)}
                    />
                ) : (
                    <input
                        ref={this.input}
                        // id={"filter_selection_" + (this.props.id || this.props.name) + "_input"}
                        name={this.props.name}
                        value={this.props.isMultiSelect ? this.getMultiSelectText() : this.state.filter}
                        disabled={this.props.disabled}
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        spellCheck="false"
                        className={!this.props.skipValidation && this.isInvalid() ? "is-invalid input" : "input"}
                        onFocus={() => {
                            this._onInputFocus.bind(this);
                            this.setState({isDropdownOpen: true})
                        }}
                        onBlur={() => {
                            this._onInputBlur.bind(this);
                            this.setState({isDropdownOpen: false})
                        }}
                        onChange={ this._onInputChange.bind(this)}
                        onKeyDown={this.props.isMultiSelect ? this._onInputChange.bind(this) : null}
                    />
                )
                }
                <span>{this.props.label}</span>
                <div className="error-icon fz fz-exclamation-triangle solid">
                    <div className="has-tooltip danger" data-tooltip={this.errorMessage()}/>
                </div>
                <div className="dropdown-indicator right-decoration fz fz-chevron-down"/>
                {this.props.isMultiSelect ?
                    <>
                        <ul ref={this.dropdown}
                            className="dropdown-container scrollbar"
                            //we use mouse down since we need event which comes before blur (otherwise the dropdown is already closed
                            onMouseDown={this._onDropdownClick.bind(this)}
                            onMouseMove={this._onDropdownMouseMove.bind(this)}
                            // onFocus={() => this.setState({isDropdownOpen: true})}
                            // onBlur={() => this.setState({isDropdownOpen: false})}
                            onMouseDownCapture={(e) => this.props.isMultiSelect && e.preventDefault()}>
                            {
                                this.state.multiselectItems.map((option, index) =>
                                    this.getOptionVisible(option) &&
                                    <li
                                        className={(this.props.isMultiSelect && this.state.multiselectItems.includes(this.getOptionValue(option))) ? "selected" : ""}
                                        key={index}
                                        data-index={index}
                                        data-id={this.getOptionValue(option)}
                                    >
                                        <input
                                            type="checkbox"
                                            id={"checkbox" + index}
                                            data-index={index}
                                            data-id={this.getOptionValue(option)}
                                            checked={this.props.isMultiSelect &&
                                                ((
                                                        this.state.multiselectValues.includes(this.getOptionValue(option))
                                                    )
                                                    ||
                                                    this.state.multiselectItems.indexOf((it) => this.getOptionCode(it) === this.getOptionCode(option)) !== -1
                                                    ||
                                                    this.state.multiselectItems.indexOf((it) => this.getOptionValue(it) === this.getOptionValue(option)) !== -1
                                                    ||
                                                    this.state.multiselectItems.includes(option))}
                                            onChange={(e) => {
                                                // console.log("onChange", e);
                                            }}
                                        />
                                        {this.getOptionLabel(option)}
                                    </li>
                                )
                            }
                            <div data-index={-1}
                                 className={"empty line " + ((this.props.isMultiSelect && this.state.multiselectItems.length > 0 && this.state.options.length > 0) ? "show" : "")}
                                 data-id={null}>
                            </div>
                            {
                                this.state.options
                                    .filter(opt => !this.state.multiselectValues.includes(this.getOptionValue(opt))
                                    ).map((option, index) => {
                                    if (this.state.multiselectValues.includes(option.id)) {
                                        return null;
                                    }
                                    return this.getOptionVisible(option) && (
                                        <li
                                            className={(this.props.isMultiSelect && this.state.multiselectValues.includes(this.getOptionValue(option))) ? "selected" : ""}
                                            key={index + this.state.multiselectItems.length}
                                            data-index={index + this.state.multiselectItems.length}
                                            data-id={this.getOptionValue(option)}
                                            ref={(this.props.hasMoreOptions && !this.props.loading && index === this.state.options
                                                .filter(opt => !this.state.multiselectValues.includes(this.getOptionValue(opt))
                                                ).length - 1) ? this.placeholderRef : null}
                                        >
                                            <input
                                                type="checkbox"
                                                id={index + this.state.multiselectItems.length}
                                                data-index={index + this.state.multiselectItems.length}
                                                data-id={this.getOptionValue(option)}
                                                checked={this.props.isMultiSelect &&
                                                    ((
                                                            this.state.multiselectValues.includes(this.getOptionValue(option))
                                                            // &&
                                                            // this.state.multiselectCodes.includes(this.getOptionCode(option))
                                                        )
                                                        ||
                                                        this.state.multiselectItems.indexOf((it) => this.getOptionCode(it) === this.getOptionCode(option)) !== -1
                                                        ||
                                                        this.state.multiselectItems.indexOf((it) => this.getOptionValue(it) === this.getOptionValue(option)) !== -1
                                                        ||
                                                        this.state.multiselectItems.includes(option))}
                                                onChange={(e) => {console.log("onChange", e); }}

                                            />
                                            {this.getOptionLabel(option)}
                                        </li>
                                    );
                                })
                            }
                            <>
                                <div
                                    tabIndex={-1}
                                    className={"loading empty"}
                                    data-index={-2}
                                    data-id={null}
                                >
                                    {this.props.loading &&
                                        <li
                                            style={{padding: '8px'}} key={"finalLoader"}><ShimmerLoader/></li>}

                                    {this.props.hasMoreOptions && !this.props.loading &&
                                        (!this.state.options || this.state.options.length === 0 ||
                                        0 === this.state.options
                                        .filter(opt => !this.state.multiselectValues.includes(this.getOptionValue(opt))
                                        ).length
                                        ) && (
                                        // this is initially triggering a fetch with intersectionObserver
                                        <li
                                            ref={this.placeholderRef} style={{padding: '8px'}}
                                            key={"finalOptionDisplayed1"}>Loading more
                                            options...</li>)
                                    }
                                </div>
                            </>


                        </ul>
                    </>
                    :
                    <ul ref={this.dropdown}
                        className="dropdown-container scrollbar"
                        //we use mouse down since we need event which comes before blur (otherwise the dropdown is already closed
                        onMouseDown={this._onDropdownClick.bind(this)}
                        onMouseMove={this._onDropdownMouseMove.bind(this)}>
                        {
                            this.state.emptyOption &&
                            <li data-index={-1} className="empty"
                                data-id={null}>{this.props.emptyLabel || "\u00A0"}</li>
                        }
                        {
                            this.state.options.map((option, index) =>
                                this.getOptionVisible(option) &&
                                <li key={index}
                                    data-index={index}
                                    data-id={this.getOptionValue(option)}>{this.getOptionLabel(option)}</li>
                            )
                        }
                    </ul>
                }

            </label>
        )
    }

    getValue() {
        const val = super.getValue() ? super.getValue() : this.props.selectedItem;
        const item = this.props.options.find(function (item) {
            return item === val ||
                String(this.getOptionValue(item)) === String(val) ||
                this.getOptionValue(item) === this.getOptionValue(val);
        }.bind(this));

        if (val && (this.props.isMultiSelect && isArray(val))) {
            val.forEach((stage) => {
                if (!this.state.multiselectItems.includes(stage) &&
                    typeof stage === "object" &&
                    stage !== null &&
                    stage !== undefined) {
                    this.state.multiselectItems.push(stage);
                    this.state.multiselectValues.push(this.state.optionsValue(stage));
                }
            });
        }
        return item ? this.getOptionLabel(item) : "";
    }

    getValueProps() {
        return "selectedItem";
    }

    getEventValue(item) {
        return item;
    }

    getMultiSelectText() {
        if(this.state.multiselectItems.length === 0) {
            return "";
        }
        return this.state.multiselectItems.map(item => this.getOptionLabel(item)).join(", ")  ;
    }

    isInvalid() {
        return this.props.isInvalid || super.isInvalid();
    }

    getOptionVisible(option) {
        return option && this.props.optionsVisible ? this.props.optionsVisible(option) : true;
    }

    getOptionValue(option) {
        if (!option) {
            return "";
        }
        if (typeof option === "object" || isArray(option)) {
            if (isArray(option)) {
                return option.filter(it => !!it).map(el => this.getOptionValue(el));
            }
            return this.state.optionsValue(option);
        } else {
            return option;
        }
    }

    _getOptionValueFunction() {
        switch (typeof this.props.optionsValue) {
            case "function":
                return this.props.optionsValue;
            case "string":
                return item => item[this.props.optionsValue];
            default:
                return item => item["name"];
        }
    }
    getOptionCode(option) {
        if (option == null || typeof option !== "object") {
            return option;
        }
        return option && option[this.props.optionsCode];
    }

    getOptionLabel(option) {
        if (!option) {
            return "";
        }
        if (typeof option === "object") {
            if (isArray(option)) {
                return option.filter(it => !!it).map(it => this.getOptionLabel(it)).join(", ");
            }
            return this.state.optionsLabel(option);
        } else {
            return option;
        }
    }

    _getLabelFunction() {
        switch (typeof this.props.optionsLabel) {
            case "function":
                return this.props.optionsLabel;
            case "string":
                return item => item[this.props.optionsLabel];
            default:
                return item => item["name"];
        }
    }

    _onInputChange(event) {
        if (!this.props.isMultiSelect) {
            const filter = event.currentTarget.value.toLowerCase();
            console.log("filter select", filter);
            let options = this.props.options;
            if (this.props.options) {
                options = this.props.options.filter(function (option) {
                    return this.getOptionLabel(option).toLowerCase().indexOf(filter) > -1;
                }.bind(this));
            }

            if (this.currentHover) {
                //hover item which will be visible after filtering
                let item = this.currentHover;
                if (this.currentHover.classList.contains("empty")) {
                    item = this.currentHover.nextElementSibling;
                } else {
                    let index = parseInt(this.currentHover.getAttribute("data-index"));
                    while (options.length <= index && item) {
                        item = item.previousElementSibling;
                        index--;
                    }
                }
                item && this._hoverItem(item);
            }

            this.setState({
                ...this.state,
                emptyOption: filter.length > 0 ? false : this.props.emptyOption,
                options: options ?? [],
                filter: filter
            });
            return
        }

        if (this.state.searchText !== event.currentTarget.value) {

            this.state.searchText = event.currentTarget.value;
            this.props.onSearchQueryChange && this.props.onSearchQueryChange(event.currentTarget.value);

            const options = []
            this.setState({
                ...this.state,
                options: options,
            });
            // if (this.currentHover) {
            //     //hover item which will be visible after filtering
            //     let item = this.currentHover;
            //     if (this.currentHover.classList.contains("empty")) {
            //         item = this.currentHover.nextElementSibling;
            //     } else {
            //         let index = parseInt(this.currentHover.getAttribute("data-index"));
            //         while (options.length <= index && item) {
            //             item = item.previousElementSibling;
            //             index--;
            //         }
            //     }
            //     item && this._hoverItem(item);
            // }
        }


    }

    _onInputKeyDown(event) {
        let item;
        let visibleHover;
        switch (event.key) {
            case "Enter":
                if (this.currentHover) {
                    this._selectOption(this.currentHover);
                }
                if (!this.props.isMultiSelect) this.input.current.blur();
                event.preventDefault();
                return false;
            case "Tab":
                if (this.currentHover) {
                    this._selectOption(this.currentHover);
                }
                if (this.props.isMultiSelect) event.preventDefault();

                break;
            case "Escape":
                this.input.current.blur();
                break;
            case "ArrowDown":
                if (this.currentHover && this.currentHover.nextElementSibling) {
                    item = this.currentHover.nextElementSibling
                } else {
                    item = this.dropdown.current.firstElementChild;
                }
                visibleHover = item.nextElementSibling ? item.nextElementSibling : item;

                this._makeOptionVisible(item, "DOWN");
                this._hoverItem(item);


                event.preventDefault();
                return false;
            case "ArrowUp":
                if (this.currentHover && this.currentHover.previousElementSibling) {
                    item = this.currentHover.previousElementSibling;
                } else {
                    item = this.dropdown.current.lastElementChild;
                }
                visibleHover = item.previousElementSibling ? item.previousElementSibling : item;

                this._makeOptionVisible(item, "UP");
                this._hoverItem(item);

                event.preventDefault();
                return false;
        }
    }

    _onInputFocus(event ) {
        const value = this.getValue();

        const option = this.state.options.find(option => option === value || this.getOptionValue(option) === value);
        // if (!this.props.isMultiSelect)
            if (option) {
                const optionValue = String(this.getOptionValue(option));
                for (let i = 0; i < this.dropdown.current.children.length; i++) {
                    const item = this.dropdown.current.children[i];
                    if (item.getAttribute("data-id") === optionValue) {
                        this._hoverItem(item);
                        break;
                    }
                }
            } else if (this.dropdown.current.firstElementChild) {
                this._hoverItem(this.dropdown.current.firstElementChild);
            }
        this.props.onFocus && event && this.props.onFocus(event);
    }

    _onInputBlur(event) {
        const value = event.currentTarget.value;
        const item = this.props.options.find(function (option) {
            return value === this.getOptionLabel(option);
        }.bind(this));
        // if (!this.props.isMultiSelect)
            if (!item) {
                this.setState({
                    ...this.state,
                    emptyOption: this.props.emptyOption,
                    options: [...this.props.options],
                    filter: this.props.emptyOption ? "" : this.state.lastValue
                    // filter: this.props.emptyOption ? "" : this.props.isMultiSelect ? "" : this.state.lastValue
                });
            } else {
                // save selected item, to it is hovered when reopened
                for (let i = 0; i < this.dropdown.current.children.length; i++) {
                    let option = this.dropdown.current.children[i];
                    if (option.getAttribute("data-id") === this.getOptionValue(item)) {
                        this.currentHover = option;
                    }
                }
            }

        this.onBlur();
    }

    _onDropdownMouseMove(event) {
        if (event.target.tagName.toUpperCase() === "LI") {
            this._hoverItem(event.target);
        }
    }

    _onDropdownClick(event) {
        this._selectOption(event.target);
    }

    _hoverItem(item) {
        if (this.currentHover) {
            this.currentHover.classList.remove("hoverPosition");
            this.currentHover.classList.remove(":hover");
        }
        this.currentHover = item;
        this.currentHover.classList.add("hoverPosition");
        this.currentHover.classList.add(":hover");
    }

    _selectOption(option) {
        const id = option.getAttribute("data-id");
        let item = id ? this.props.options.find(function (option) {
            return id === String(this.getOptionValue(option));
        }.bind(this)) : null;

        if (!item) {
            item = id ? this.state.multiselectItems.find(function (option) {
                return id === String(this.getOptionValue(option));
            }.bind(this)) : null;
        }

        this.setState({
            ...this.state,
            emptyOption: this.props.emptyOption,
            options: [...this.props.options],
            filter: this.getOptionLabel(item),
            lastValue: this.getOptionLabel(item),
        })

        if (typeof this.props.onChange !== "undefined") {
            this.props.onChange();
        }
        if (this.props.isMultiSelect && item) {

            const elementIndex = this.state.multiselectValues.indexOf(this.getOptionValue(item));
            if (elementIndex === -1 && (this.getOptionValue(item) || item)) {
                this.state.multiselectValues.push(this.getOptionValue(item));
                this.state.multiselectItems.push(item);
            } else {
                this.state.multiselectValues.splice(elementIndex, 1);
                this.state.multiselectItems.splice(elementIndex, 1);
            }

            this.setState(prevState => {
                // This feels somewhat unnecessary
                const uniqueItems = [];
                const seenCodes = new Set();

                for (const item of prevState.multiselectItems) {
                    if (!seenCodes.has(this.getOptionValue(item)) &&
                        !!prevState.multiselectValues &&
                        prevState.multiselectValues.includes(this.getOptionValue(item))) {
                        uniqueItems.push(item);
                        seenCodes.add(this.getOptionValue(item));
                    }
                }

                return {multiselectItems: uniqueItems};
            });

            if (!this.props.isSelectionAnObject) {
                this.onChange(this.state.multiselectValues);
            } else {
                this.onChange(this.state.multiselectItems);
            }

            return;
        }
        !!item && this.onChange(this.getOptionValue(item));
    }

    _makeOptionVisible(option, direction) {
        const parent = option.parentElement;
        if (option.offsetTop < parent.scrollTop || //top visible
            option.offsetTop + option.clientHeight > parent.scrollTop + parent.clientHeight) { //bottom visible
            //not 100% visible
            if (direction === "UP") {
                parent.scrollTop = option.offsetTop;
            } else {
                parent.scrollTop = option.offsetTop + option.clientHeight - parent.clientHeight;
            }
        }
    }
}

Select.propTypes = {
    id: PropTypes.string,
    options: PropTypes.array.isRequired,
    optionsValue: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    isSelectionAnObject: PropTypes.bool,
    optionsCode: PropTypes.string,
    optionsLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    optionsVisible: PropTypes.func,
    selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array]),
    emptyOption: PropTypes.bool,
    emptyLabel: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    skipValidation: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    formField: PropTypes.object,
    isMultiSelect: PropTypes.bool,
    multiSelectValues: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onSearchQueryChange: PropTypes.func,
    loading: PropTypes.bool,
    fetchMoreOptions: PropTypes.func,
    hasMoreOptions: PropTypes.bool,
};

PropTypes.defaultProps = {
    emptyOption: true,
    emptyLabel: "",
    optionsValue: "id",
    optionsLabel: "name",
    optionsCode: "code",
    optionsVisible: () => true,
    isMultiSelect: false,
    isSelectionAnObject: false,
    onSearchQueryChange: () => {
    },
}

export default Select
